const urls = {
  //#region 用户
  userUserlist: '/api/light/user/userlist',
  userAppLogin: '/api/light/user/appLogin',
  userAiLogin: '/api/light/user/aiLogin',
  userAiAdd: '/api/light/user/aiAdd',
  userAiGuestAdd: '/api/light/user/aiGuestAdd',
  userLogout: '/api/light/user/logout',
  userGetInfo: '/api/light/user/getInfo',
  userGetUserInfoById: '/api/light/user/getUserInfoById',
  userAppEdit: '/api/light/user/appEdit',
  userCaptcha: '/api/light/user/captcha',
  userSendEmailCode: '/api/light/user/sendEmailCode',
  userEditPassword: '/api/light/user/editPassword',
  userCreateToken: '/api/light/user/createToken',
  userGetCcInfo: '/api/light/user/getCcInfo',
  //#endregion

  //#region 邮件
  emailCustomSend: '/api/light/email/customSend',
  //#endregion    

  //#region 兑换
  exchangeCodeAppUse: '/api/light/exchangeCode/appUse',
  //#endregion   
  
  //#region 课节
  lessonSearch: '/api/light/lesson/search',
  lessonSearchForVideoQuestion: '/api/light/lesson/searchForVideoQuestion',
  lessonAppGetById: '/api/light/lesson/appGetById',
  lessonAppGetByIdForSelect: '/api/light/lesson/appGetByIdForSelect',
  //#endregion    

  //#region 配置
  configGetHomeTabs: '/api/light/config/getHomeTabs',
  configGetMeData: '/api/light/config/getMeData',
  configBase: '/api/light/config/base',
  configChatList: '/api/light/config/chatList',
  configWelcome: '/api/light/config/welcome',


  //#endregion

  //#region 推荐
  recommendGetNormalList: '/api/light/home/recommend/getNormalList',
  //#endregion     

  //#region 分类
  categoryGetData: '/api/light/home/category/getData',
  //#endregion   
  
  //#region 行为
  behaviorLessonAction: '/api/light/behavior/lessonAction',
  behaviorLessonHistoryAction: '/api/light/behavior/lessonHistoryAction',
  behaviorLessonStatus: '/api/light/behavior/lessonStatus',
  behaviorLessonSearch: '/api/light/behavior/lessonSearch',
  behaviorFollowAction: '/api/light/behavior/followAction',
  behaviorCourseUserStatus: '/api/light/behavior/courseUserStatus',
  behaviorUserSearch: '/api/light/behavior/userSearch',
  behaviorFansSearch: '/api/light/behavior/fansSearch',  
  behaviorAppInviterExchangeHistorySearch: '/api/light/behavior/appInviterExchangeHistorySearch',      

  //#endregion     
  
  //#region 上传
  uploadGetTokenForH5: '/api/light/upload/getTokenForH5',
  uploadToCDN: 'https://upload-z1.qiniup.com',
  uploadFile: '/api/light/upload/file',
  //#endregion    

  //#region 评论
  commentSearch: '/api/light/comment/search',
  commentGetReplyListById: '/api/light/comment/getReplyListById',
  commentAdd: '/api/light/comment/add',
  commentLike: '/api/light/comment/like',
  commentSoftDelete: '/api/light/comment/softDelete',
  //#endregion     

  //#region 对话
  talkAppSearch: '/api/light/talk/appSearch',
  talkAdminSearch: '/api/light/talk/adminSearch',
  talkDelete: '/api/light/talk/delete',
  talkEdit: '/api/light/talk/edit',
  //#endregion  
  
  //#region 聊天记录
  chatSearch: '/api/light/chat/search',
  chatAdd: '/api/light/chat/add',
  chatEditForNewTalk: '/api/light/chat/editForNewTalk',
  chatSearchForRealPeople: '/api/light/chat/searchForRealPeople',
  chatAddForRealPeople: '/api/light/chat/addForRealPeople',
  chatListSearch: '/api/light/chat/listSearch',
  chatDelete: '/api/light/chat/delete',
  chatEdit: '/api/light/chat/edit',
  chatAddAudio: '/api/light/chat/addAudio',
  chatGoogleSearch: '/api/light/chat/googleSearch',
  chatStreamTest: '/api/light/chat/streamTest',
  chatCreateChatCompletion: '/api/light/chat/createChatCompletion',
  chatRealTimeAdd: '/api/light/chat/realTimeAdd',

  //#endregion 

  //#region 真人对话
  realTalkAppSearch: '/api/light/realTalk/appSearch',
  realTalkAdminSearch: '/api/light/realTalk/adminSearch',
  realTalkAdd: '/api/light/realTalk/add',
  realTalkDelete: '/api/light/realTalk/delete',
  realTalkEdit: '/api/light/realTalk/edit',
  //#endregion

  //#region 真人聊天
  realChatAppSearch: '/api/light/realChat/appSearch',
  realChatAdminSearch: '/api/light/realChat/adminSearch',
  realChatAdd: '/api/light/realChat/add',
  realChatGroupAdd: '/api/light/realChat/groupAdd',
  realChatDelete: '/api/light/realChat/delete',
  realChatEdit: '/api/light/realChat/edit',
  //#endregion    

  //#region 画图
  sdAppSearch: '/api/light/sd/appSearch',
  sdSearchForSimpleSd: '/api/light/sd/searchForSimpleSd',
  sdImgSearch: '/api/light/sd/imgSearch',
  sdAdd: '/api/light/sd/add',
  sdUploadPicture: '/api/light/sd/uploadPicture',
  sdPromptSearch: '/api/light/sd/promptSearch',
  sdGetImgListByModelId: '/api/light/sd/getImgListByModelId',
  sdGetInfoById: '/api/light/sd/getInfoById',
  sdUpscale: '/api/light/sd/upscale',



  //#endregion      

  //#region 文件列表
  fileAppSearch: '/api/light/file/appSearch',
  fileAdminSearch: '/api/light/file/adminSearch',
  fileAdd: '/api/light/file/add',
  fileDelete: '/api/light/file/delete',
  fileEdit: '/api/light/file/edit',
  fileTranscriptions: '/api/light/file/transcriptions',
  fileWisperForH5: '/api/light/file/whisperForH5',
  fileMoYin: '/api/light/file/moYin',
  //#endregion   

  //#region words
  wordsAppSearch: '/api/light/words/appSearch',
  wordsGetById: '/api/light/words/getById',
  //#endregion  

  //#region 朋友圈
  friendsAppSearch: '/api/light/friends/appSearch',
  friendsAdminSearch: '/api/light/friends/adminSearch',
  friendsAdd: '/api/light/friends/add',
  friendsDelete: '/api/light/friends/delete',
  friendsEdit: '/api/light/friends/edit',
  //#endregion    

  //#region 文本转语音
  textToAudioAppSearch: '/api/light/textToAudio/appSearch',
  textToAudioAdminSearch: '/api/light/textToAudio/adminSearch',
  textToAudioAdd: '/api/light/textToAudio/add',
  textToAudioDelete: '/api/light/textToAudio/delete',
  textToAudioEdit: '/api/light/textToAudio/edit',
  textToAudioOnAzure: '/api/light/textToAudio/onAzure',
  textToAudioGetById: '/api/light/textToAudio/getById',

  //#endregion    

  //#region mj
  mjAppSearch: '/api/light/mj/appSearch',
  mjAdd: '/api/light/mj/add',
  mjGetWaitlist: '/api/light/mj/getWaitlist',
  mjGetDrawingInfo: '/api/light/mj/drawingInfo',
  mjGetById: '/api/light/mj/getById',
  mjDownload: '/api/light/mj/download',
  //#endregion 

  //#region aiVideo
  aiVideoAppSearch: '/api/light/aiVideo/appSearch',
  aiVideoAdminSearch: '/api/light/aiVideo/adminSearch',
  aiVideoAdd: '/api/light/aiVideo/add',
  aiVideoEditForStatus: '/api/light/aiVideo/editForStatus',
  aiVideoDelete: '/api/light/aiVideo/delete',
  aiVideoEdit: '/api/light/aiVideo/edit',
  aiVideoEditExplore: '/api/light/aiVideo/editExplore',
  aiVideoCdnDelete: '/api/light/aiVideo/cdnDelete',

  //#endregion    

  //#region 助理
  assistantsSearch: '/api/light/assistants/search',
  assistantsThreadDelete: '/api/light/assistants/threadDelete',
  //#endregion

  //#region 工具
  toolsGetUrlContent: '/api/light/tools/getUrlContent',
  toolsCompressImages: '/api/light/tools/compressImages',
  //#endregion  

  //#region chromium
  chromiumSearch: '/api/light/chromium/search',
  chromiumGetPageSize: '/api/light/chromium/getPageSize',
  //#endregion  
  
}

export default urls
